<ng-container *ngIf="total > 0; else dash">
  <samp [tooltip]="activeTemplate" placement="left" container="body">{{ total }}</samp>
</ng-container>

<ng-template #activeTemplate>
  <table class="tt-details">
    <tbody>
      <tr *ngIf="activated > 0" class="tr-align-center">
        <td class="text-left">{{ 'SLOTS.STATUS.STOP.2' | translate }}</td>
        <td class="text-right">{{ activated }}</td>
      </tr>
      <tr *ngIf="arrived > 0" class="tr-align-center">
        <td class="text-left">{{ 'SLOTS.STATUS.STOP.5' | translate }}</td>
        <td class="text-right">{{ arrived }}</td>
      </tr>
      <tr *ngIf="unloaded > 0" class="tr-align-center">
        <td class="text-left">{{ 'SLOTS.STATUS.STOP.3' | translate }}</td>
        <td class="text-right">{{ unloaded }}</td>
      </tr>
    </tbody>
  </table>
</ng-template>

<ng-template #dash>
  <span class="text-muted">&#8212;</span>
</ng-template>
